import { render, staticRenderFns } from "./SmplEditBomChild.vue?vue&type=template&id=a9ae3172&scoped=true&"
import script from "./SmplEditBomChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditBomChild.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditBomChild.vue?vue&type=style&index=0&id=a9ae3172&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ae3172",
  null
  
)

export default component.exports